'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./spinner.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Spinner = function Spinner(_ref) {
  var size = _ref.size,
      propsToPassOn = _objectWithoutProperties(_ref, ['size']);

  var className = 'spinner spinner-' + (size || 'small');

  return _react2.default.createElement(
    'span',
    _extends({ className: className }, propsToPassOn),
    _react2.default.createElement('i', { className: 'fa fa-spinner fa-spin' })
  );
};

Spinner.propTypes = {
  size: _propTypes2.default.oneOf(['small', 'large', 'extra-large', 'button'])
};

exports.default = Spinner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/components/Spinner.js
// module id = 843
// module chunks = 0